import {
  MousePointer2,
  Crop,
  Pencil,
  Type,
  Square,
  Eraser,
  PaintBucket,
  Pipette,
} from 'lucide-react';
import type { EditorTool } from '../types';

interface ToolPaletteProps {
  activeTool: EditorTool;
  onToolSelect: (tool: EditorTool) => void;
}

const tools: {
  id: EditorTool;
  icon: React.ComponentType<{ className?: string }>;
  label: string;
}[] = [
  { id: 'select', icon: MousePointer2, label: 'Select (V)' },
  { id: 'crop', icon: Crop, label: 'Crop (C)' },
  { id: 'draw', icon: Pencil, label: 'Draw (B)' },
  { id: 'text', icon: Type, label: 'Text (T)' },
  { id: 'shape', icon: Square, label: 'Shape (U)' },
  { id: 'eraser', icon: Eraser, label: 'Eraser (E)' },
  { id: 'fill', icon: PaintBucket, label: 'Fill (G)' },
  { id: 'eyedropper', icon: Pipette, label: 'Eyedropper (I)' },
];

export function ToolPalette({ activeTool, onToolSelect }: ToolPaletteProps) {
  return (
    <div className="flex flex-col items-center gap-1 w-14 bg-background border-r border-border py-2 px-1">
      {tools.map((tool) => {
        const Icon = tool.icon;
        const isActive = activeTool === tool.id;
        return (
          <button
            key={tool.id}
            type="button"
            title={tool.label}
            className={`w-10 h-10 flex items-center justify-center rounded-md transition-colors ${
              isActive
                ? 'bg-primary text-primary-foreground'
                : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground'
            }`}
            onClick={() => onToolSelect(tool.id)}
          >
            <Icon className="h-5 w-5" />
          </button>
        );
      })}
    </div>
  );
}
